/**
 * 分类资源
 * 2017-11-22
 * Bai.Zhiming
 */
'use strict';
angular.module('classifiedResourceModule', [
    'classifiedResourceLeftModule', // 分类资源左侧导航
    'classifiedResourceRouterModule', // 分类资源路由
    'resCenWebsiteModule',
    'resCenDigitalPreviewModule',
    'resCenWechatModule',
    'resCenNewWeiboModule',
    'resCenAppModule',
    'resCenClassifiedPictureModule', // 图片素材
    'resCenClassifiedVideoModule', // 视频素材
]);
